<template>
  <div>
    <el-form
      :model="listForm"
      ref="editPage"
      :rules="releaseRules"
      label-width="160px"
    >
      <div class="errorTipTop">
        <i class="el-icon-warning"></i>
        <span>{{listFormCp.empName}}薪资交易失败，反馈银行：{{listFormCp.bankType | dictFilter(dicts)}}，错误原因：{{listFormCp.bankFeedback}}，退票时间：{{listFormCp.recordTime}}</span>
      </div>
      <el-container>
        <el-container>
          <el-aside width="300px">
            {{listFormCp.empName}}
          </el-aside>
          <div class="editForm errorRead">
            <el-row>
              <el-col :span="12">
                <el-form-item label="银行类别">
                  <p class="formText">{{listFormCp.bankType | dictFilter(dicts) }}</p>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="支付类型">
                  <p class="formText">{{listFormCp.payClass | dictFilter(dicts)}}</p>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开户名">
                  <p class="formText">{{listFormCp.accountName}}</p>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="计税类型">
                  <p class="formText">{{listFormCp.taxType | dictFilter(dicts)}}</p>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开户账号">
                  <p class="formText">{{listFormCp.accountNo}}</p>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="支付金额">
                  <p class="formText">{{listFormCp.amount}}</p>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-container>
      </el-container>
      <div class="rightSideTitle">更新银行信息</div>
      <div class="editForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="开户名" prop="upOpenName">
              <el-input v-model="listForm.upOpenName"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户账号" prop="upAccountNumber">
              <el-input v-model="listForm.upAccountNumber"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行类别" prop="bankType">
              <bsp-dicts-select
                v-model="listForm.bankType"
                @selectChange="changeBankType"
                :select-value.sync="listForm.bankType"
                ref="select9527"
                dic-num="3151"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户行全称" prop="upBankFullName">
              <el-input v-model="listForm.upBankFullName"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="账户地区" prop="upAccountArea">
              <el-input v-model="listForm.upAccountArea"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工行地区代码" prop="upIbicAreNum">
              <el-input v-model="listForm.upIbicAreNum"/>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!--********************在途发放记录*********************-->
      <!--<provide-records
        v-if="tabName=='private'"
        ref="provideRecords"
        :empId="this.empId"
        :refundId="this.refundId"
        :listForm="listForm"
      />-->

    </el-form>
  </div>
</template>

<script>
  import bspDictsSelect from "@/components/bsp/bsp-dicts-select/bsp-dicts-select";
  import provideRecords from "./provideRecords";
  import { getRefundEditValue } from "@/api/biz/refund/refund";
  import { dictFilter } from "@/filters/index";
  import { mapGetters } from "vuex";

  export default {
    components: {
      bspDictsSelect,
      provideRecords
    },

    name: "Dialog",
    props: {
      listForm: {
        type: Object,
        default: () => (
          {}
        )
      },
      dialogFormVisible: {
        type: Boolean,
        default: false
      },
      dialogStatus: {
        type: String,
        default: ""
      },
      refundId: {
        type: Number,
        default: 0
      },
      tabName: {
        type: String,
        default: ""
      },
      empId:{
        type:Number,
        default:0
      }
    },
    watch: {
      listForm: {
        handler(newVal, oldVal) {
          // 在监听你使用update事件来更新listForm,而在父组件不需要调用该函数
          this.$emit("update:listForm", newVal);
        },
        immediate: true,
        deep: true
      }
    },
    created() {
      this.init();
    },
    mounted() {
      //this.resetForm('listForm');
    },
    computed: {
      ...mapGetters([
        'dicts', "memberInfo"
      ])
    },
    data() {
      return {
        listFormCp:{},
        disabled: true,
        showCropAvatar: false,
        photo: "",
        parameter: {
          refundId: 0
        },
        empName: "",
        memberId: 0,
        businessReviewerList: [],
        businessReviewerId: 0,
        businessLeaderName: "",
        businessLeaderId: "",
        copyListFrom: {},
        formData: {},
        releaseRules: {
          upOpenName: [
            { required: true, message: "不能为空", trigger: "blur" },
            /*{ min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }*/
            { max: 50, message: "长度不能超过50个字符", trigger: "blur" }
          ],
          upAccountNumber: [
            { required: true, message: "不能为空", trigger: "blur" },
            { max: 32, message: "长度不能超过32个字符", trigger: "blur" }
          ],
          upBankFullName: [
            { required: true, message: "不能为空", trigger: "blur" }
          ],
          upAccountArea: [
            { required: true, message: "不能为空", trigger: "blur" }
          ]
        },
        sexList: [
          { value: "1", label: "女" },
          { value: "2", label: "男" }
        ]
      };
    },
    methods: {
      init() {
        this.parameter.refundId = this.refundId;
        this._getRefundEditFormValue(this.parameter);
      },
      toggleShowCropAvatar() {
        this.showCropAvatar = !this.showCropAvatar;
      },
      handleUploadSuccess(res, field) {
        this.listForm.photo = res.fileId;
      },
      _getRefundEditFormValue() {
        console.log("编辑页面this.parameter=", this.parameter);
        getRefundEditValue(this.parameter).then(res => {
          console.log("getRefundEditValue====", res);
          if(res.data.data != null){
            this.formData = res.data.data;
            this.empName = this.listForm.empName;
            this.listForm = res.data.data;
            this.$nextTick(()=>{
              //this.$set(this.listForm,'bankType',this.formData.bankType)
              this.$refs.select9527.initData()
              console.log(this.$refs.select9527)
            })
            //this.$set(this.$data,'listForm',res.data.data)
            this.$set(this.$data,'listFormCp',Object.assign({},this.formData))
            console.log(JSON.stringify(this.listFormCp))
          }
        });
      },
      /**
       * 清空表单
       * @param searchForm
       */
      resetForm(formName) {
        let th = this;
        if (this.$refs[formName] !== undefined) {
          console.log("qing kong form");
          this.$refs[formName].resetFields();
        }
      },

      //业务复核人改变时将id传给父页面
      businessReviewerChange(val) {
        this.listForm.businessReviewer = val;
        let obj = {};
        obj = this.businessReviewerList.find((item) => {//这里的userRoleList就是上面遍历的数据源
          return item.id === val;//筛选出匹配数据
        });
        this.listForm.businessReviewerName = obj.name;
        // this.$emit('update:listForm.businessReviewer',val);
        // this.$emit('update:listForm.businessReviewerName',val);
        this.$emit("getbusinessReviewer", obj.id, obj.name);
        this.$forceUpdate();
      },
      selectedValue() {

      },
      // 获取银行code
      changeBankType(bankType) {
        this.listForm.bankType = bankType
      }


    }
  };
</script>
<style scoped>
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .haredFnot {
    font-size: 20px;
  }

  .customer-info-item {
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
    background-color: #ddf4ff;
    color: #008AFF;
    font-size: 16px;
  }

  .customer-info-title {
    display: flex;
    align-items: center;
  }

  .customer-info-title .icon {
    margin-right: 10px;
    font-size: 24px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    margin-left: 30px;
    margin-bottom: 5px;
  }

  .avatar {
    width: 50px;
    height: 50px;
    display: block;
    margin-left: 30px;
    margin-bottom: 5px;
  }

  .el-aside {
    color: #333;
    font-size: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
